import { animate, state, style, transition, trigger } from "@angular/animations";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Component, OnDestroy, OnInit } from "@angular/core";
import { SkeletonModel } from "app/shared/components/skeleton/models/skeletonModel";
import { Toolbar } from "app/shared/model/toolbar.model";
import { ConfigService } from "app/shared/services/config.service";
import { DblinkedSessionService } from "app/shared/services/dblinked-session.service";
import { HttpService } from "app/shared/services/http.service";
import { SessionService } from "app/shared/services/session.service";
import { TitleService } from "app/shared/services/title.service";
import { ToolbarService } from "app/shared/services/toolbar.service";
import { MessageService } from "primeng/api";
import { Subscription } from "rxjs/Subscription";


@Component({
  selector: 'unidade-medida',
  templateUrl: './unidade-medida.component.html',
  styleUrls: ['./unidade-medida.component.scss'],
  animations: [
    trigger('changeDivSize', [
      state('initial', style({

      })),
      state('final', style({
        opacity: '0',
        height: '0',
        padding: '0px 15px',

      })),
      transition('initial=>final', animate('200ms')),
      transition('final=>initial', animate('200ms'))
    ]),
  ]
})

export class UnidadeMedida implements OnInit, OnDestroy {

  private sessionSubscription: Subscription

  httpOptions: Object = new Object()
  lista: Array<any> = new Array()
  listUnidadesDisponiveis: Array<any> = new Array()
  listUnidadesVinculadas: Array<any> = new Array()
  vincularUnidadeMedida: boolean = false
  unidadeSelecionada: number = null
  skeletonConfig = new SkeletonModel({
    columns: [
      { name: 'CÓDIGO', textAlign: 'left' },
      { name: 'DESCRIÇÃO', textAlign: 'left' }
    ],
    hasFilter: true,
    hasSort: true
  })

  constructor(
    private titleService: TitleService,
    private toolbarService: ToolbarService,
    private dblinkedSessionService: DblinkedSessionService,
    private sessionService: SessionService,
    private configService: ConfigService,
    private httpClient: HttpClient,
    private messageService: MessageService,
    private httpService: HttpService
  ) { }

  ngOnInit() {
    this.titleService.title = "Unidade Medida"
    this.toolbarService.hidden = true
    this.dblinkedSessionService.hidePeriods()
    this.httpOptions = { headers: new HttpHeaders({ Authorization: this.configService.bearerApi }) }
    this.sessionSubscription = this.sessionService.initSubscribe(
      this.dblinkedSessionService.sessionChanged,
      async () => {
        this.buscarRegistros()
      })
  }

  ngOnDestroy() {
    this.toolbarService.hidden = false
    this.sessionService.destroySubscribe(this.sessionSubscription)
  }

  get pageLinks() {
    return this.configService.applicationConfig.pageLinks;
  }

  get rows() {
    return this.configService.applicationConfig.rows;
  }

  get rowsPerPage() {
    return this.configService.applicationConfig.rowsPerPage;
  }

  async buscarRegistros() {
    this.skeletonConfig.startLoad()
    try {
      await this.httpClient.get(this.configService.defaultUrlApiUpload + "util/unidade-medida", this.httpOptions).toPromise()
        .then(res => {
          this.lista = new Array()
          res["data"].forEach(element => {
            this.lista.push(element)
          })
        })
        .catch(error => this.messageService.add({ severity: 'error', key: 'messageLinnks', summary: '', detail: 'Erro ao recuperar os registros, contate o suporte.' }))
    } catch {
      this.messageService.add({ severity: 'error', key: 'messageLinnks', summary: '', detail: 'Erro ao recuperar os registros, contate o suporte.' })
    } finally {
      this.skeletonConfig.endLoad()
    }
  }

  onRowClick(row: any) {
    this.unidadeSelecionada = row.id
    this.listUnidadesDisponiveis = new Array()
    this.listUnidadesVinculadas = new Array()
    this.vincularUnidadeMedida = false
    this.obterVinculacao()
  }

  async obterVinculacao() {
    this.httpService.wait()
    try {
      await this.httpClient.get(this.configService.defaultUrlApiUpload + "util/unidade-medida?id=" + this.unidadeSelecionada, this.httpOptions).toPromise()
        .then(res => {
          this.vincularUnidadeMedida = true
          res["data"]["disponiveis"].forEach(element => {
            this.listUnidadesDisponiveis.push(element)
          })
          res["data"]["vinculadas"].forEach(element => {
            this.listUnidadesVinculadas.push(element)
          })
        })
        .catch(error => this.messageService.add({ severity: 'error', key: 'messageLinnks', summary: '', detail: 'Erro ao recuperar os registros, contate o suporte.' }))
    } catch {
      this.messageService.add({ severity: 'error', key: 'messageLinnks', summary: '', detail: 'Erro ao recuperar os registros, contate o suporte.' })
    } finally {
      this.httpService.done()
    }
  }

  async salvarVinculacao() {
    let infos = {
      unidade_id: this.unidadeSelecionada,
      livinculado: this.listUnidadesVinculadas
    }

    this.httpService.wait()
    try {
      await this.httpClient.post(this.configService.defaultUrlApiUpload + "util/unidade-medida", infos, this.httpOptions).toPromise()
        .then(res => {
          this.messageService.add({ severity: 'success', key: 'messageLinnks', summary: 'Sucesso', detail: res["message"] })
        })
        .catch(error => this.messageService.add({ severity: 'error', key: 'messageLinnks', summary: '', detail: 'Erro ao recuperar os registros, contate o suporte.' }))
    } catch {
      this.messageService.add({ severity: 'error', key: 'messageLinnks', summary: '', detail: 'Erro ao recuperar os registros, contate o suporte.' })
    } finally {
      this.httpService.done()
    }
  }
}

